// extracted by mini-css-extract-plugin
export default {"centerdiv":"ADLoginLoading_centerdiv__znCMu","bounce":"ADLoginLoading_bounce__6qZGA","loading-message":"ADLoginLoading_loading-message__RDqht"};